"use client"
import { setFooterTab } from '@/redux/features/filterSlice'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

const FooterContacts = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch()

    return (
        <div className='footer__contacts'>
            <div className='footer__phone-mail'>
                <div className='footer__phone'>
                    <div className='footer__phone-order'>
                        <p className='footer__contacts-text'>
                            {t("weAreInTouch")}{' '}
                            <span>
                                <span
                                    onClick={()=>{dispatch(setFooterTab(3))}}
                                    className='footer__phone-order-link'
                                    style={{cursor: "pointer"}}
                                >
                                    <span>{t("orderACall")}</span>
                                </span>
                            </span>
                        </p>
                    </div>
                    <a
                        className='footer__phone-number'
                        href='tel:+78442979797'
                    >
                        +7 (8442) 97-97-97
                    </a>
                </div>
                <div className='footer__mail'>
                    <p className='footer__contacts-text'>{t("WeAreReadyToAcceptYourRequestByMail")}</p>
                    <Link
                        href='mailto:info@megamix.ru'
                        className='footer__mail-link'
                    >
                        info@megamix.ru
                    </Link>
                </div>
            </div>
            <div className='footer__media'>
                <a
                    href='/files/press-kit.pdf'
                    download
                    className='footer__media-download'
                >
                    <p>{t("DownloadPressKit")}</p>
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M13.2569 0.999884C13.2569 0.668513 12.9882 0.399884 12.6569 0.399884L7.25685 0.399884C6.92548 0.399884 6.65685 0.668513 6.65685 0.999884C6.65685 1.33125 6.92548 1.59988 7.25685 1.59988L12.0569 1.59988L12.0569 6.39988C12.0569 6.73125 12.3255 6.99988 12.6569 6.99988C12.9882 6.99988 13.2569 6.73125 13.2569 6.39988L13.2569 0.999884ZM6.57574 6.23247C6.34142 6.46679 6.34142 6.84669 6.57574 7.081C6.81005 7.31532 7.18995 7.31532 7.42426 7.081L6.57574 6.23247ZM7.42426 7.081L13.0811 1.42415L12.2326 0.57562L6.57574 6.23247L7.42426 7.081Z'
                            fill='#FF727E'
                        />
                    </svg>
                </a>
                <div className='footer__media-text'>
                    <p className='footer__contacts-text'>
                        {t("PressService")}: <br />
                        {/* <br />
                        <a
                            href='tel:+78442979797'
                            className='footer__contacts-text'
                        >
                            +7 (8442) 97-97-97, доб. 356
                        </a> */}
                        <br />
                        <a style={{ color: 'inherit' }} href="mailto:press@megamix.ru">press@megamix.ru</a>
                    </p>
                </div>
                <div className='footer__media-social'>
                    <a
                        target='_blank'
                        href='https://vk.com/megamix_official'
                        className='footer__media-social-link' rel="noreferrer"
                    >
                        <svg
                            width='44'
                            height='44'
                            viewBox='0 0 44 44'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M23.8498 33.2055C24.9534 33.2055 25.4046 32.5033 25.3919 31.6228C25.3357 28.307 26.6857 26.5219 29.1228 28.8484C31.8191 31.4222 32.3772 33.2055 35.6515 33.2055H41.45C42.9141 33.2055 43.4903 32.7558 43.4903 32.0501C43.4903 30.5573 40.9155 27.923 38.7338 25.9892C35.6787 23.2822 35.5356 23.2182 38.1666 19.9594C41.4301 15.9136 45.6992 10.7297 41.923 10.7297H34.7093C33.3104 10.7297 33.2089 11.4821 32.7106 12.603C30.9077 16.6626 27.4811 21.9209 26.1801 21.1166C24.8193 20.2777 25.4426 16.9549 25.5459 12.0166C25.5731 10.7124 25.5658 9.81815 23.4784 9.35459C22.3386 9.10378 21.2297 9 20.2004 9C16.0817 9 13.2404 10.6484 14.855 10.9355C17.7016 11.4423 17.428 17.3216 16.7648 19.8608C15.6088 24.282 11.2635 16.3599 9.45332 12.4144C9.01662 11.4666 8.88253 10.7297 7.32419 10.7297H1.42606C0.534547 10.7297 0 11.0065 0 11.6222C0 12.6635 5.36359 23.2459 10.4844 28.5215C15.4783 33.6674 20.4142 33.2055 23.8498 33.2055Z'
                                fill='#83A3EB'
                            />
                        </svg>
                    </a>
                    <a
                        target='_blank'
                        href='https://www.youtube.com/@megamix_official'
                        className='footer__media-social-link' rel="noreferrer"
                    >
                        <svg
                            width='44'
                            height='44'
                            viewBox='0 0 44 44'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M34.515 7.30079C28.5408 6.89892 15.2347 6.90055 9.26883 7.30079C2.80894 7.73533 2.04807 11.5808 2 21.7027C2.04807 31.8066 2.80231 35.6684 9.26883 36.1046C15.2364 36.5049 28.5408 36.5065 34.515 36.1046C40.9748 35.6701 41.7357 31.8246 41.7838 21.7027C41.7357 11.5988 40.9815 7.73696 34.515 7.30079ZM16.9189 28.2371V15.1683L30.1802 21.6913L16.9189 28.2371Z'
                                fill='#83A3EB'
                            />
                        </svg>
                    </a>
                    <a
                        target='_blank'
                        href='https://t.me/gk_megamix'
                        className='footer__media-social-link' rel="noreferrer"
                    >
                        <svg
                            width='39'
                            height='39'
                            viewBox='0 0 39 39'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <g clipPath='url(#clip0_3877_1430)'>
                                <path
                                    fillRule='evenodd'
                                    clipRule='evenodd'
                                    d='M29.15 36.1181C29.6606 36.4796 30.3186 36.57 30.9053 36.348C31.4919 36.1245 31.9232 35.6234 32.0532 35.0161C33.4311 28.5406 36.7735 12.1504 38.0277 6.25996C38.1229 5.816 37.9643 5.35459 37.6155 5.05809C37.2666 4.76158 36.783 4.67596 36.3518 4.83611C29.7034 7.29694 9.22874 14.9791 0.860018 18.0757C0.328847 18.2724 -0.0168106 18.7829 0.000630831 19.3426C0.0196579 19.9039 0.397027 20.3907 0.940883 20.554C4.69396 21.6766 9.62038 23.2384 9.62038 23.2384C9.62038 23.2384 11.9226 30.1912 13.1229 33.7271C13.2736 34.171 13.6208 34.5199 14.079 34.6404C14.5357 34.7593 15.0241 34.634 15.365 34.3121C17.293 32.4919 20.2739 29.6775 20.2739 29.6775C20.2739 29.6775 25.9376 33.8301 29.15 36.1181ZM11.6927 22.36L14.3549 31.141L14.9464 25.5803C14.9464 25.5803 25.2321 16.3031 31.0955 11.0151C31.2668 10.8597 31.2906 10.5997 31.1479 10.4174C31.0068 10.235 30.7467 10.1922 30.5517 10.3159C23.7559 14.6556 11.6927 22.36 11.6927 22.36Z'
                                    fill='#83A3EB'
                                />
                            </g>
                            <defs>
                                <clipPath id='clip0_3877_1430'>
                                    <rect
                                        width='38.0541'
                                        height='38.0541'
                                        fill='white'
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default FooterContacts
